import { getFirebaseInstance } from 'firebaseAPI/firebaseAdapter';
import { StatusNewsItem } from '../pages/AdminPage';

export const STATUS_NEWS_COLLECTION = 'statusNews';
export const STATUS_NEWS_LAYER = 'portal';
export const STATUS_NEWS_ITEMS = 'items';

export const fetchStatusNewsItems = async (): Promise<StatusNewsItem[]> => {
  try {
    const db = getFirebaseInstance().firestore();
    const itemsRef = db
      .collection(STATUS_NEWS_COLLECTION)
      .doc(STATUS_NEWS_LAYER)
      .collection(STATUS_NEWS_ITEMS);
    const snapshot = await itemsRef.get();
    return snapshot.docs.map(
      (doc) => ({ ...doc.data(), id: doc.id } as StatusNewsItem),
    );
  } catch (error) {
    console.error('Error fetching status news items:', error);
    alert('Error fetching status news items');
    return [];
  }
};

export const createStatusNewsItem = async (
  item: Omit<StatusNewsItem, 'id'>,
): Promise<string> => {
  try {
    const db = getFirebaseInstance().firestore();
    const itemsRef = db
      .collection(STATUS_NEWS_COLLECTION)
      .doc(STATUS_NEWS_LAYER)
      .collection(STATUS_NEWS_ITEMS);
    const docRef = await itemsRef.add(item);
    return docRef.id;
  } catch (error) {
    console.error('Error creating status news item:', error);
    alert('Error creating status news item');
    throw error;
  }
};

export const updateStatusNewsItem = async (
  id: string,
  item: Partial<StatusNewsItem>,
): Promise<void> => {
  try {
    const db = getFirebaseInstance().firestore();
    const itemRef = db
      .collection(STATUS_NEWS_COLLECTION)
      .doc(STATUS_NEWS_LAYER)
      .collection(STATUS_NEWS_ITEMS)
      .doc(id);
    await itemRef.update(item);
  } catch (error) {
    console.error('Error updating status news item:', error);
    alert('Error updating status news item');
    throw error;
  }
};

export const deleteStatusNewsItem = async (id: string): Promise<void> => {
  try {
    const db = getFirebaseInstance().firestore();
    const itemRef = db
      .collection(STATUS_NEWS_COLLECTION)
      .doc(STATUS_NEWS_LAYER)
      .collection(STATUS_NEWS_ITEMS)
      .doc(id);
    await itemRef.delete();
  } catch (error) {
    console.error('Error deleting status news item:', error);
    alert('Error deleting status news item');
    throw error;
  }
};
